<div class="enviar-caso-container white-panel" id="enviar-caso" #rootElement>
    <div class="container">
        <div class="row">
            <div class="col-4">
                <div>
                    <img src="https://api.bealign.com/img/contenidos/25.jpg" class="img-fluid" />
                </div>
                <div class="text-center mt-3">
                    <a class="btn btn-primary" [routerLink]="['/login']">Acceder a mi cuenta</a>
                </div>
            </div>
            <div class="col-8">
                <h2>Regístrese y tendrá acceso a lo siguiente:</h2>
                <div class="mt-3" [innerHTML]="textoRegistrese">

                </div>
            </div>
        </div>
    </div>
</div>